(() => {
  'use strict';

  if (window.RwadyContentHeaderTicker) {
    window.RwadyContentHeaderTicker.mountAll();
    return;
  }

  const SELECTOR = '[data-rwady-content-header-ticker]';
  const ICON_PATHS = {
    delivery: ['M3 6h11v10H3z', 'M14 9h3l4 4v3h-7z', 'M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z', 'M18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'],
    quality: ['M12 3l2.1 2.1 3-.4.4 3L20 10l-1.5 2.6.7 2.9-2.9.7L14 19l-2-2-2 2-2.3-2.8-2.9-.7.7-2.9L4 10l2.5-2.3.4-3 3 .4z', 'm9 11 2 2 4-4'],
    exchange: ['M7 7h12l-3-3', 'm19 7-3 3', 'M17 17H5l3 3', 'm5 17 3-3'],
    trending: ['m4 16 5-5 4 4 7-8', 'M15 7h5v5'],
    warranty: ['M12 3 5 6v5c0 4.6 2.8 7.7 7 10 4.2-2.3 7-5.4 7-10V6z', 'm9 12 2 2 4-4']
  };

  function safeHref(raw) {
    if (typeof raw !== 'string') return null;
    const value = raw.trim();
    if (!value || /[\\\s\u0000-\u001f\u007f]/.test(value) || value.startsWith('//')) return null;
    if (value.startsWith('/')) return value;
    try {
      const url = new URL(value);
      return url.protocol === 'https:' ? url.href : null;
    } catch (_) {
      return null;
    }
  }

  function icon(name) {
    const paths = ICON_PATHS[name];
    if (!paths) return null;
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('rwady-content-header-ticker__icon');
    paths.forEach((value) => {
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', value);
      svg.appendChild(path);
    });
    return svg;
  }

  function itemNode(item) {
    const href = safeHref(item && item.url);
    const node = document.createElement(href ? 'a' : 'span');
    node.className = 'rwady-content-header-ticker__item';
    if (item && item.kind === 'button') {
      node.classList.add('rwady-content-header-ticker__item--button');
    }
    if (href) {
      node.href = href;
      if (href.startsWith('https://')) node.rel = 'noopener';
    }

    const itemIcon = icon(item && item.icon);
    if (itemIcon) node.appendChild(itemIcon);

    const label = typeof (item && item.text) === 'string' ? item.text.trim() : '';
    if (label) {
      const text = document.createElement('span');
      text.textContent = label;
      node.appendChild(text);
    }

    return node.childNodes.length ? node : null;
  }

  function applyStyle(root, payload) {
    const color = payload && payload.colors ? payload.colors : {};
    const padding = payload && payload.padding ? payload.padding : {};
    root.style.setProperty('--rwady-ticker-bg', color.background || '#0941AD');
    root.style.setProperty('--rwady-ticker-color', color.text || '#FFFFFF');
    root.style.setProperty('--rwady-ticker-gap', Math.max(0, Number(payload.spacing) || 0) + 'px');
    root.style.setProperty('--rwady-ticker-speed', Math.max(6, Number(payload.speedSeconds) || 20) + 's');
    root.style.setProperty('--rwady-ticker-padding-top', Math.max(0, Number(padding.top) || 0) + 'px');
    root.style.setProperty('--rwady-ticker-padding-bottom', Math.max(0, Number(padding.bottom) || 0) + 'px');
    root.dataset.pauseHover = payload.pauseOnHover ? 'true' : 'false';
  }

  function renderContinuous(root, viewport, payload, nodes) {
    const track = document.createElement('div');
    const direction = payload.direction === 'left' ? 'left' : 'right';
    track.className = 'rwady-content-header-ticker__track rwady-content-header-ticker__track--' + direction;

    ['primary', 'duplicate'].forEach((name) => {
      const group = document.createElement('div');
      group.className = 'rwady-content-header-ticker__group';
      group.setAttribute('dir', payload.locale === 'ar' ? 'rtl' : 'ltr');
      if (name === 'duplicate') group.setAttribute('aria-hidden', 'true');
      nodes.forEach((node) => group.appendChild(node.cloneNode(true)));
      track.appendChild(group);
    });

    viewport.appendChild(track);
  }

  function renderSlideshow(root, viewport, payload, nodes) {
    const slide = document.createElement('div');
    slide.className = 'rwady-content-header-ticker__slide';
    slide.setAttribute('dir', payload.locale === 'ar' ? 'rtl' : 'ltr');
    viewport.appendChild(slide);

    let index = 0;
    const show = () => {
      slide.replaceChildren(nodes[index].cloneNode(true));
      index = (index + 1) % nodes.length;
    };
    show();

    if (!window.RwadyMotionTest && nodes.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root._rwadyTickerTimer = window.setInterval(show, Math.max(2, Number(payload.speedSeconds) || 4) * 1000);
    }
  }

  function syncHeaderHeight() {
    window.requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));
      try {
        const store = window.Alpine && window.Alpine.store && window.Alpine.store('xHeaderMenu');
        if (store && typeof store._syncHeaderHeightVar === 'function') store._syncHeaderHeightVar();
      } catch (_) {
        // The Maximize header store is optional while the page boots.
      }
    });
  }

  function render(root, payload) {
    const viewport = root.querySelector('[data-rwady-ticker-viewport]');
    if (!viewport) return;
    if (root._rwadyTickerTimer) window.clearInterval(root._rwadyTickerTimer);
    root._rwadyTickerTimer = null;
    viewport.replaceChildren();

    const nodes = Array.isArray(payload && payload.items)
      ? payload.items.map(itemNode).filter(Boolean)
      : [];

    if (!payload || payload.enabled !== true || nodes.length === 0) {
      root.hidden = true;
      syncHeaderHeight();
      return;
    }

    applyStyle(root, payload);
    if (payload.mode === 'slideshow') renderSlideshow(root, viewport, payload, nodes);
    else renderContinuous(root, viewport, payload, nodes);

    root.hidden = false;
    root.dataset.contentVersion = String(payload.contentVersion || 0);
    syncHeaderHeight();
  }

  async function load(root) {
    if (!root || root.dataset.rwadyTickerMounted === 'true') return;
    root.dataset.rwadyTickerMounted = 'true';

    const endpoint = root.dataset.endpoint;
    const locale = root.dataset.locale === 'en' ? 'en' : 'ar';
    const device = window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
    if (!endpoint) {
      root.removeAttribute('data-rwady-ticker-pending');
      return;
    }

    const url = new URL(endpoint);
    url.searchParams.set('locale', locale);
    url.searchParams.set('device', device);
    url.searchParams.set('channel', 'web');

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(url.href, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'X-Rwady-Client': 'shopify-theme' },
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Ticker request failed');
      render(root, await response.json());
    } catch (_) {
      root.hidden = true;
      root.dataset.rwadyTickerState = 'unavailable';
      syncHeaderHeight();
    } finally {
      root.removeAttribute('data-rwady-ticker-pending');
      window.clearTimeout(timeout);
    }
  }

  function mountAll(scope) {
    const parent = scope && scope.querySelectorAll ? scope : document;
    parent.querySelectorAll(SELECTOR).forEach(load);
  }

  window.RwadyContentHeaderTicker = { mountAll };
  mountAll();

  document.addEventListener('shopify:section:load', (event) => mountAll(event.target));
})();
